<template>
  <!-- Modal Despacho a Domicilio -->
  <div
    class="modal fade"
    id="domicilio"
    tabindex="-1"
    role="dialog"
    aria-labelledby="domicilio"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-body text-center modal-contenido">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <template v-if="selectedAddress != ''">
            <h3>Despacho a domicilio programado</h3>
            <p>Elija el día de su preferencia.</p>

            <div class="lugar-hora-precio table-responsive">
              <table class="table table-bordered">
                <thead class="thead-gris">
                  <tr>
                    <th scope="col">
                      <small><strong>Horario</strong></small>
                    </th>
                    <th
                      scope="col"
                      v-for="(item, index) in homeDeliveryOptions.weekOne"
                      :key="index"
                      @click="selectDeliveryOptions(item, selectedAddressDesc)"
                    >
                      <small>
                        {{ item.delivery_date | esDatewName }}
                      </small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekOne" :key="index">
                      {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">-</th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekOne" :key="index">
                      <a
                        href
                        data-dismiss="modal"
                        @click="selectDeliveryOptions(item, selectedAddressDesc)"
                        ><small>Seleccionar</small></a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="lugar-hora-precio table-responsive">
              <table class="table table-bordered">
                <thead class="thead-gris">
                  <tr>
                    <th scope="col">
                      <small><strong>Horario</strong></small>
                    </th>
                    <th
                      scope="col"
                      v-for="(item, index) in homeDeliveryOptions.weekTwo"
                      :key="index"
                      @click="selectDeliveryOptions(item, selectedAddressDesc)"
                    >
                      <small>
                        {{ item.delivery_date | esDatewName }}
                      </small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekTwo" :key="index">
                      {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">-</th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekTwo" :key="index">
                      <a
                        href
                        data-dismiss="modal"
                        @click="selectDeliveryOptions(item, selectedAddressDesc)"
                        ><small>Seleccionar</small></a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else>
            <h3>Advertencia</h3>
            <p>Debe seleccionar una dirección de despacho para continuar.</p>
            <div class="text-center">
              <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { config_settings } from '@/config.js';
import { getHomeDeliverysOptions } from '@/service/delivery.service.js';

export default {
  name: 'HomeDelivery',
  props: [
    'selectedAddress',
    'selectedAddressDesc',
    'selectedDelivery',
    'totalValue',
    'selectedAddressDistrict',
  ],
  data() {
    return {
      homeDeliveryOptions: [],
    };
  },
  methods: {
    getHomeDeliveryOptions() {
      getHomeDeliverysOptions(this.selectedAddressDistrict, this.totalValue)
        .then((response) => {
          this.homeDeliveryOptions = response.data;
        })
        .catch((error) => {});
    },

    selectDeliveryOptions(item, place) {
      this.$parent.selectDelivery(
        item.id_delivery,
        'Despacho a domicilio',
        place,
        item.delivery_cost,
        item.delivery_date,
        item.delivery_schedule,
      );
    },
  },
  watch: {
    selectedAddressDistrict() {
      this.getHomeDeliveryOptions();
    },
  },
};
</script>
